import { Skeleton } from '@radix-ui/themes';
import { PitchDesign } from 'components/sections/pitch-design';
import useLatest from 'hooks/useLatestRef';
import { useEffect } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import { useCookiesStore } from 'stores/use-cookies-store';
import { usePitchDesignStore } from 'stores/use-pitch-design-store';

export const PitchDesignRoute = () => {
  const current = useAuthStore((s) => s.current);

  const priority = useCookiesStore((s) => s.app.build_priority);
  const latestPriority = useLatest(priority);

  // reset the PD store using the latest priority but do not repeat this when priority changes
  useEffect(() => {
    // the pitch is always new using this view
    usePitchDesignStore.setState({
      isNew: true,
      showCurrent: false,
    });

    // rebuilds everything using the default pitch
    usePitchDesignStore.getState().resetInputs(latestPriority.current);
  }, []);

  // wait for auth and machine context before rendering anything
  if (!current.auth) {
    return <Skeleton height="50%" />;
  }

  // pitch can only be saved as new
  return <PitchDesign identifier="StandalonePitchDesigner" />;
};
